<div class="service-input-details-container">
    <form [formGroup]="serviceInputsForm" class="form-container" [ngClass]="{ 'insert-input': !readOnly }">
        <!-- Select Service (only in create request form) -->
        <div class="input-container select" *ngIf="selectServiceList">
            <label class="input-label">{{ 'service' | translate }}</label>
            <mat-form-field appearance="standard" class="service-select input" [dir]="'rtl'">
                <mat-icon matSuffix><span class="material-symbols-outlined"> expand_more </span></mat-icon>
                <mat-select [(value)]="serviceBrief" (selectionChange)="onServiceChange($event)">
                    <mat-option *ngFor="let service of selectServiceList" [value]="service">
                        {{ service.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Service Input (only in view request) -->
        <div class="input-container" *ngIf="readOnly">
            <span class="input-label">{{ 'service' | translate }}</span>
            <div class="input-content input custom-visible-scroll">
                {{ serviceBrief?.name }}
            </div>
        </div>

        <!-- Date Range -->
        <app-date-range-input
            formGroupName="requiredFormGroup"
            class="input-container"
            *ngIf="displayDateRange"
            [endDateInput]="endDateInput"
            [startDateInput]="startDateInput"
            [serviceInputsForm]="serviceInputsForm"
            [readOnly]="readOnly"
            (onChange)="passServiceInputFormToParent()"
        ></app-date-range-input>

        <!-- Time Range -->
        <app-time-range-input
            formGroupName="requiredFormGroup"
            class="input-container"
            *ngIf="displayTimeRange"
            [endTimeInput]="endTimeInput"
            [startTimeInput]="startTimeInput"
            [serviceInputsForm]="serviceInputsForm"
            [readOnly]="readOnly"
            (onChange)="passServiceInputFormToParent()"
            [endDateInput]="endDateInput"
            [startDateInput]="startDateInput"
        ></app-time-range-input>

        <!-- Service Inputs (excluding date range or time range inputs) -->
        <div
            class="input-container"
            *ngFor="let inputItem of serviceInputList"
            [ngClass]="{
                hide: inputItem.inputType === inputType.DATE_RANGE || inputItem.inputType === inputType.TIME_RANGE || inputItem.hidden
            }"
        >
            <div *ngIf="inputItem.inputType !== inputType.DATE_RANGE && inputItem.inputType !== inputType.TIME_RANGE">
                <div formGroupName="atLeastOneRequiredFormGroup" class="input-form">
                    <label class="formlabel input-label" for="{{ inputItem.labelName }}"> {{ inputItem.labelName | translate }}</label>
                    <input
                        class="input-content input custom-visible-scroll"
                        type="text"
                        formControlName="{{ inputItem.controlName }}"
                        id="{{ inputItem.labelName }}"
                        name="{{ inputItem.labelName }}"
                        [readonly]="readOnly"
                        type="{{ inputItem.inputType }}"
                        (keyup)="passServiceInputFormToParent()"
                        (keydown)="onKeyDown($event, inputItem)"
                    />
                    <mat-hint
                        class="char-count"
                        *ngIf="
                            !readOnly &&
                            valueLengthInputsArray.includes(inputItem.id) &&
                            atLeastOneRequiredFormGroup.get(inputItem.controlName).value.length > 0
                        "
                        >{{ atLeastOneRequiredFormGroup.get(inputItem.controlName).value.length }}</mat-hint
                    >
                    <mat-hint class="hint-as-error" *ngIf="inputItem.hasError && inputItem.errorMessage">
                        {{ inputItem.errorMessage | translate }}
                    </mat-hint>
                </div>
            </div>
        </div>
    </form>
</div>
